module.exports = __webpack_public_path__ + "img/logotipoUFV2.3da79334.png";